import { Link } from 'react-router-dom';
import { trpc } from '@/lib/trpc';
import { Spinner, ThemeToggle } from './EnvLayout';

/** mrpanadol.com/environmental — logo on a clean page, one button per game. */
export default function EnvironmentalHub() {
  const { data: games, isLoading, isError } = trpc.environmental.games.useQuery();

  return (
    <main className="mx-auto flex max-w-3xl flex-col items-center px-4 pb-16 pt-10 md:pt-14">
      <div className="absolute right-3 top-3"><ThemeToggle /></div>
      <img src="/logo.png" alt="MrPanadol" className="h-28 w-28 object-contain md:h-36 md:w-36" />

      {isLoading && <Spinner />}
      {isError && <p className="mt-12 text-slate-500 dark:text-slate-400">Couldn't load the games. Please refresh.</p>}

      {games && (
        <nav aria-label="Games"
             className="mt-10 grid w-full grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4">
          {games.map(g => (
            <Link key={g.id} to={`/environmental/${g.slug}`}
                  className="flex min-h-[96px] items-center justify-center rounded-2xl bg-yellow-400 px-4 py-6
                             text-center text-lg font-bold leading-tight text-black shadow-sm
                             transition-all hover:-translate-y-0.5 hover:bg-yellow-300 hover:shadow-md
                             active:translate-y-0">
              {g.title}
            </Link>
          ))}
        </nav>
      )}

      <Link to="/environmental/admin" className="mt-16 text-sm text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300">
        Admin
      </Link>
    </main>
  );
}
